import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="container">
        <header className="about-header">
          <div className="section-label">Our Story</div>
          <h1 className="about-title">About Shree Photos</h1>
        </header>

        <div className="about-content">
          <div className="about-image-collage reveal-left">
            <div className="collage-img-1">
              <img src="https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=800&q=80" alt="Master Photographer" />
            </div>
            <div className="collage-img-2">
              <img src="https://images.unsplash.com/photo-1516589091380-5d8e87df6999?w=800&q=80" alt="Photography Equipment" />
            </div>
            <div className="collage-img-3">
              <img src="https://images.unsplash.com/photo-1606800052052-a08af7148866?w=800&q=80" alt="Studio Setup" />
            </div>
          </div>

          <div className="about-text reveal-right">
            <p>
              I am a former information technology professional with extensive experience in India.
              In due course, I chose to pursue my passion for photography and successfully
              transformed it into a full-time career.
            </p>
            <p>
              Shree Photos is a professional photography firm dedicated to providing a
              comprehensive range of services, thoughtfully tailored to meet the distinct
              requirements of our clients. We are committed to upholding the highest
              standards of quality, while ensuring timely delivery and cost efficiency.
            </p>
            <p>
              Our team of accomplished photographers and editors brings over two decades
              of industry expertise, enabling us to capture moments with exceptional
              precision and artistic excellence. We invite you to review our portfolio
              to discover how we can bring your vision to fruition.
            </p>
          </div>
        </div>

        <section className="philosophy-section">
          <div className="philosophy-header reveal">
            <h2>The Wedding Experience</h2>
            <div className="divider"></div>
          </div>

          <div className="philosophy-content">
            <div className="philosophy-column reveal-scale stagger-1">
              <div className="philosophy-image">
                <img src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80" alt="Wedding Couple" />
              </div>
              <p>
                Your wedding day should be a true reflection of who you are, rather than
                resembling a staged production. My role is to create photographs that you
                will cherish not only for their visual quality but also for the memories
                and emotions they preserve.
              </p>
              <p>
                It is of utmost importance to me that you remain relaxed and fully present
                throughout your celebration. Weddings often progress swiftly, with evolving
                schedules and heightened emotions. I maintain a calm and steady approach,
                ensuring that you need not concern yourself with the photographic process.
              </p>
            </div>

            <div className="philosophy-column reveal-scale stagger-2">
              <p>
                At times, I work unobtrusively to capture candid moments; at others, I
                offer thoughtful guidance during portrait sessions. There are also
                occasions when I remain nearby, providing a reassuring presence—whether
                through light conversation or a brief pause. I integrate seamlessly into
                the event, stepping forward when required and withdrawing when appropriate.
              </p>
              <p>
                I am particularly attentive to the subtle, in-between moments that often
                carry the greatest meaning. Establishing a genuine rapport is essential.
                The more comfortable you feel, the more natural and authentic your
                photographs will be.
              </p>
              <div className="philosophy-highlight">
                At the heart of it all lies what matters most - the love you share.
              </div>
              <div className="philosophy-image margin-top-image">
                <img src="https://images.unsplash.com/photo-1537633552985-df8429e8048b?w=800&q=80" alt="Wedding Detail" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
